import { render, staticRenderFns } from "./ReportManage.vue?vue&type=template&id=524f5f52&scoped=true&"
import script from "./ReportManage.vue?vue&type=script&lang=ts&"
export * from "./ReportManage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524f5f52",
  null
  
)

export default component.exports